<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_memoryX') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}
            span(slot="value") {{ parameters.difficult.amountOfRows + ' x ' + parameters.difficult.amountOfColumns }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numbers') }}
            span(slot="value") {{ settings.numbers.join(', ') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_operations') }}
            span(slot="value") {{ operations }}
</template>

<script>
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';
    import { camelCase } from 'lodash';

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
        computed: {
            operations() {
                const fields = [];
                for (let key in this.settings.operations) {
                    this.settings.operations[key] && fields.push(key);
                }
                return fields
                    .map(field => this.$i18n.t(`trainer.trainer_gameFormSetting_operation${this.pascalCase(field)}`))
                    .join(', ');
            },
        },
        methods: {
            pascalCase(word) {
                word = camelCase(word);
                return word.charAt(0).toUpperCase() + word.slice(1);
            },
        },
    };
</script>
